import { call, put } from 'redux-saga/effects';
import CouponsService from 'services/couponsService';
import FileService from 'services/fileservice';
import { createAndDownloadFile } from 'utils/functions/generals';
import {
  loadFile,
  loadFileFailure,
  loadFileSuccess,
} from '../generals/file/actions';
import { loadCouponSuccess, loadCouponFailure } from './actions';

export function* loadCouponsSaga(action: any) {
  try {
    const { data, total } = yield call(
      CouponsService.getAllCoupons,
      action.payload.query,
    );
    yield put(loadCouponSuccess({ total, data }));
  } catch (err) {
    yield put(loadCouponFailure());
  }
}

export function* loadCouponsFileSaga(action: any) {
  try {
    yield put(loadFile());
    const file = yield call(
      FileService.getFile,
      action.payload.query,
      action.payload.rootPath,
    );
    if (file?.response?.status) {
      yield put(loadFileFailure());
    } else {
      yield put(loadFileSuccess());
      createAndDownloadFile(file, 'Cupons.xls');
    }
  } catch (error) {
    yield put(loadFileFailure());
  }
}
